"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = build;

var _versionComparer = _interopRequireDefault(require("./versionComparer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function build(writeKey, integrations, version, culture, tenant) {
  const scriptId = getScriptId(version);
  const trackingScript = " \n      (function(a,b,c,d){\n        if(window.tracking)return;\n        a='https://tracking.cdn.vpsvc.com/';\n        b=document;c='script';d=b.createElement(c);d.src=a+'".concat(getTrackingRelativeUrl(version), "';d.type='text/java'+c;\n        d.async=true;d.id=\"").concat(scriptId, "\";d.setAttribute(\"data-write-key\",\"").concat(writeKey, "\");\n        ").concat(integrations ? "d.setAttribute(\"data-integrations\",\"".concat(serializeIntegrations(integrations), "\");") : "", "\n        ").concat(culture ? "d.setAttribute(\"data-culture\",\"".concat(culture, "\");") : "", "\n        ").concat(tenant ? "d.setAttribute(\"data-tenant\",\"".concat(tenant, "\");") : "", "\n        a=b.getElementsByTagName(c)[0];a.parentNode.insertBefore(d,a);\n      })();\n      ");
  return trackingScript;
}

function getScriptId(version) {
  if (!version || (0, _versionComparer.default)(version, "2.3.0") >= 0) {
    return "tracking-vp-dcp";
  }

  return "tracking";
}

function serializeIntegrations(integrations) {
  return JSON.stringify(integrations).replace(/"/g, "'");
}

function getTrackingRelativeUrl(version) {
  return version ? "v/tracking-slim-".concat(version, ".min.js") : "tracking-slim.min.js";
}